/** MM-DD des heutigen Tages (lokale Zeit). */
export function todaysMmDd(date = new Date()): string {
  return `${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

/** Extrahiert MM-DD aus ISO-Datum, ISO-Datetime oder DD.MM.YYYY. */
export function birthDateMmDd(iso?: string | null): string | null {
  if (!iso) return null;
  const text = String(iso).trim();
  const isoMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) return `${isoMatch[2]}-${isoMatch[3]}`;
  const deMatch = text.match(/^(\d{1,2})\.(\d{1,2})\.\d{4}$/);
  if (deMatch) {
    return `${String(Number(deMatch[2])).padStart(2, "0")}-${String(Number(deMatch[1])).padStart(2, "0")}`;
  }
  return null;
}

export function birthDateIsToday(iso?: string | null, today = new Date()): boolean {
  const mmdd = birthDateMmDd(iso);
  return mmdd != null && mmdd === todaysMmDd(today);
}

/** Eigener Geburtstag – inkl. Dev-Simulation über Hero-Profil oder /me. */
export function isMyBirthdayToday(
  profile?: { birth_date?: string | null; dev_simulate_birthday?: boolean } | null,
  today = new Date(),
): boolean {
  if (profile?.dev_simulate_birthday) return true;
  return birthDateIsToday(profile?.birth_date, today);
}

/** Effektives Geburtsdatum für Dev-Simulation (heute, optional mit Jahr). */
export function devSimulatedBirthDateToday(birthYear?: number): string {
  const today = new Date();
  const year = birthYear ?? today.getFullYear() - 30;
  return `${String(year).padStart(4, "0")}-${todaysMmDd(today)}`;
}
